module.exports = __webpack_public_path__ + "img/arrow-down-gray.4eff5597.svg";